import { Box, Button, Drawer, IconButton } from "@mui/material";
import { Cookies } from "react-cookie";
import axios from "axios";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction, loadAlert, loadFavAlert } from "redux/reducers/top";
import { useHistory } from "react-router-dom";
import BestItems from "components/product-of-week/best-items";
import CategoryItems from "components/product-of-week/category-items";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import Loading from "components/ui/loading";
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";
import { DrawerProduct } from "components/product-of-week/drawer-product";

export default function ProductOfWeek() {
  let cookies = new Cookies();

  const imgRef = useRef([]);

  const dispatch = useDispatch();
  const history = useHistory();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [banner, setBanner] = useState("");
  const [drawerHigh, setDrawerHigh] = useState(false);
  const [flyer, setFlyer] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [token, setToken] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const { alertOpen, favAlertOpen } = useSelector((state) => state.top);

  const handleDrawerHighOpen = () => {
    setDrawerHigh(true);
  };
  const handleDrawerHighClose = () => {
    setDrawerHigh(false);
  };

  useEffect(() => {
    setFetching(true);
    setToken(cookies.get("X-AUTH-TOKEN"));
    loadBanner();
    loadFlyer();
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(
        loadAction({ back: true, title: "금주의 행사상품", menu: true })
      );
  }, [init]);

  const loadBanner = () => {
    axios
      .get(`/api/eh/leaflet-banner/get`, {
        params: { tp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1 },
      })
      .then((res) => {
        setBanner(res.data.data.leafletBanner);
      });
  };

  const loadFlyer = () => {
    let localToken = cookies.get("X-AUTH-TOKEN");
    let localFavInfo = cookies.get("favInfo");

    let stCode = localFavInfo
      ? localFavInfo.visibleTp == "1"
        ? localFavInfo.favMt
        : localFavInfo.favMk
      : "";

    axios
      .get(
        `/api/sm/store/get-leaflet/${
          localToken ? (stCode ? stCode : "2701") : "2701"
        }`
      )
      .then((res) => {
        setFlyer(res.data.data);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const slideChange = (swipe) => {
    setActiveIndex(swipe.realIndex);
    imgRef.current[swipe.previousIndex].style.setProperty(
      "transform",
      make3dTransformValue({ x: -0, y: -0, scale: 1 })
    );
  };

  const onUpdate = useCallback(({ x, y, scale }) => {
    const img = imgRef.current[activeIndex];

    if (img) {
      const value = make3dTransformValue({ x, y, scale });
      img.style.setProperty("transform", value);
    }
  });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  window.appBackKeyHandle = () => {
    if (drawerOpen) {
      handleDrawerClose();
    } else if (drawerHigh) {
      handleDrawerHighClose();
    } else if (alertOpen) {
      dispatch(loadAlert(false));
    } else if (favAlertOpen) {
      dispatch(loadFavAlert(false));
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <Loading open={fetching} />
      <main id="main" className="productOfWeek">
        <div className="banner">
          <div className="banner-img">
            {banner && <img src={banner.imgUrl} />}
          </div>
          <Button
            className="btn-rounded end-icon"
            color="primary"
            variant="contained"
            size="small"
            endIcon={<i className="ico-go-white" />}
            onClick={(e) => {
              if (token && !storeCode) dispatch(loadFavAlert(true));
              else handleDrawerHighOpen();
            }}
          >
            종이전단 보기
          </Button>
        </div>
        <div className="best-items bg-grey">
          <h3 className="weight800">BEST 추천상품</h3>
          <p className="sub-txt"></p>
          <BestItems />
        </div>
        <div className="catg-items">
          <h3 className="weight800">기획전</h3>
          <CategoryItems
            drawerOpen={drawerOpen}
            handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose}
          />
        </div>

        <DrawerProduct
          flyer={flyer}
          drawerHigh={drawerHigh}
          handleDrawerHighClose={handleDrawerHighClose}
        />
      </main>
    </>
  );
}
